import React, {Component} from 'react';
import {Button, Table} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './AssistantsList.css';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import {Link} from "react-router-dom";
import RemoveAssistantModal from "../removeAssistantModal/RemoveAssistantModal.container";
import EditAssistantModal from "../editAssistantModal/EditAssistantModal.container";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";

class AssistantsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedAssistant: null
        }
    }

    componentDidMount() {
        this.props.onMount();
    }

    render() {
        return (
            <div className='assistants-list-container'>
                <FormWrapper>
                    <h4 className="page-label">{_.get(this.props.translation, 'assistants.assistants_label')}</h4>
                    <div className="buttons-group">
                        <Button tag={Link} to="/add-assistant" onClick={this.props.onResetSubmitFormData} className='add-assistant-button olive-green-btn'>
                            {_.get(this.props.translation, sharedLabelsPath.add_button)}
                        </Button>
                    </div>
                    {this.renderContent()}
                    <RemoveAssistantModal data={this.state.selectedAssistant} onCancelRemoving={this.handleCloseModal}/>
                    <EditAssistantModal data={this.state.selectedAssistant} onCancelEditing={this.handleCloseModal}/>
                </FormWrapper>
            </div>
        )
    }

    renderContent = () => {
        if (this.props.loading) {
            return (
                <div className="assistants-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="assistants-status-message-container">
                    <h5>{_.get(this.props.translation, 'assistants.no_data_label')}</h5>
                </div>
            );
        }

        return (
            <Table className='assistants-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, sharedLabelsPath.name_label)}</th>
                    <th>{_.get(this.props.translation, 'assistants.roles_label')}</th>
                    <th/>
                    <th>{_.get(this.props.translation, sharedLabelsPath.email_label)}</th>
                    <th>{_.get(this.props.translation, 'assistants.location_label')}</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderOrgsData()}
                </tbody>
            </Table>
        );
    };

    getRolesLabel = (roles) => {
        return roles.map(role => _.get(this.props.translation, 'assistants.' + role + '_label')).join(', ');
    };

    renderOrgsData = () => {
        return _.map(this.props.data, (assistantData, index) => (
            <tr
                className={"assistants-list-row"}
                key={index}>
                <td
                    className='name-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.name_label) + ":"}>
                    {assistantData.firstName + ' ' + assistantData.lastName}
                </td>
                <td
                    className='role-td'
                    data-th={_.get(this.props.translation, 'assistants.roles_label') + ":"}>
                    {this.getRolesLabel(assistantData.roles)}
                </td>
                <td className='assistants-create-icon-td'>
                    {assistantData.hasRootPermission ? null : <IconContainer
                        key={index}
                        icon='create'
                        className='assistants-create-icon'
                        onClick={this.onEditButtonClick(assistantData)}
                        title={_.get(this.props.translation, sharedLabelsPath.edit_button)}
                    />}
                </td>
                <td
                    className='email-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.email_label) + ":"}>
                    <a href={"mailto:" + assistantData.email}>{assistantData.email}</a>
                </td>
                <td
                    className='location-td'
                    data-th={_.get(this.props.translation, 'assistants.location_label') + ":"}>
                    {assistantData.countryCode ? _.get(this.props.translation, 'countries.' + assistantData.countryCode) : null}
                </td>
                <td className='assistants-remove-icon-td'>
                    {assistantData.hasRootPermission ? null : <IconContainer
                        onClick={this.onRemoveButtonClick(assistantData)}
                        key={index}
                        icon='trash'
                        className='assistants-remove-icon'
                        title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                    />}
                </td>
            </tr>
        ));
    };

    onRemoveButtonClick = (assistant) => () => {
        this.setState({selectedAssistant: assistant});
        this.props.onRemoveButtonClick();
    };

    onEditButtonClick = (assistant) => () => {
        this.setState({selectedAssistant: assistant});
        this.props.onEditButtonClick();
    };

    handleCloseModal = () => {
        this.setState({selectedAssistant: null});
    }
}

const AssistantShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    roles: PropTypes.array.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    countryCode: PropTypes.string
});

AssistantsList.propTypes = {
    translation: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.arrayOf(AssistantShape),
    onMount: PropTypes.func.isRequired,
    onRemoveButtonClick: PropTypes.func.isRequired,
    onEditButtonClick: PropTypes.func.isRequired,
    onResetSubmitFormData: PropTypes.func.isRequired,
};

export default AssistantsList;



// WEBPACK FOOTER //
// ./src/components/assistantsManagement/assistantsList/AssistantsList.js